import { cva } from 'class-variance-authority';

const menuItemBaseStyles = [
  'min-w-[150px]',
  'py-2',
  'px-4',
  'cursor-pointer',
  'flex',
  'items-center',
  'justify-between',
];

const menuItemStylesSAG = cva([
  ...menuItemBaseStyles,
  'text-[#000028]',
  'hover:bg-[#E8E8E3]',
  'dark:text-white',
  'dark:hover:bg-[#37374D]',
]);

const menuItemStylesSHS = cva([
  ...menuItemBaseStyles,
  'text-[#1a1a1a]',
  'hover:bg-[#e6e6e6]',
  'dark:text-[#e6e6e6]',
  'dark:hover:bg-[#4d4d4d]',
]);

export { menuItemStylesSAG, menuItemStylesSHS };
